var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShieldCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.25 8.31249C2.25 5.9143 2.25 4.71521 2.53314 4.31181C2.81627 3.9084 3.94374 3.52247 6.19868 2.75059L6.62829 2.60354C7.80374 2.20118 8.39146 2 9 2C9.60854 2 10.1963 2.20118 11.3717 2.60354L11.8013 2.75059C14.0563 3.52247 15.1837 3.9084 15.4669 4.31181C15.75 4.71521 15.75 5.9143 15.75 8.31249C15.75 8.67474 15.75 9.06756 15.75 9.49352C15.75 13.7221 12.5708 15.7741 10.5761 16.6455C10.035 16.8818 9.76444 17 9 17C8.23556 17 7.96501 16.8818 7.42392 16.6455C5.42922 15.7741 2.25 13.7221 2.25 9.49352C2.25 9.06756 2.25 8.67474 2.25 8.31249Z",
    stroke: "#45AE51",
    strokeWidth: 1.125
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.125 9.8L8.19643 11L10.875 8",
    stroke: "#45AE51",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShieldCheck);
export default __webpack_public_path__ + "static/media/Shield Check.84aaa34b533c2f9bfa90ce012ae538df.svg";
export { ForwardRef as ReactComponent };